import { SelectionWithNoteMixin, SelectionWithSourceCitationMixin } from '../internal';
/**
 * @ignore
 */
export const SelectionWithNoteSourceCitationMixin = (Base) => SelectionWithSourceCitationMixin(SelectionWithNoteMixin(Base));
//# sourceMappingURL=SelectionWithNoteSourceCitationMixin.js.map